import { ApiLog } from 'dashboard/models/api-log';
import { ApiLogActions, ApiLogActionType } from 'dashboard/redux/actions/api-log';

export interface ApiLogState {
  apiLog: ApiLog | undefined;
}

const initialState: ApiLogState = {
  apiLog: undefined,
};

export default (state: ApiLogState = initialState, action: ApiLogActions) => {
  switch (action.type) {
    case ApiLogActionType.ClearApiLog: {
      return initialState;
    }

    case ApiLogActionType.SetApiLog: {
      return {
        ...state,
        apiLog: action.payload.apiLog,
      };
    }

    default:
      return state;
  }
};
